import { find, get, includes, isObject } from "lodash";

const SUPPORTED_SERVER_ANALYSIS = ["triageFull", "objectDetection", "argus"];

export function getAnalysisType(analysis) {
    return isObject(analysis) ? analysis.type : analysis;
}

export function getArgusAnalysis(analysis) {
    return find(analysis || [], item => getAnalysisType(item) === "argus");
}

export function getQuestionAnalysis(question) {
    const analysis = (get(question, "analysis", []) || []).filter(item =>
        includes(SUPPORTED_SERVER_ANALYSIS, getAnalysisType(item))
    );
    const argus = getArgusAnalysis(analysis);
    return argus ? [argus] : analysis;
}

export function getAnalysisTypes(analysis) {
    return (analysis || []).map(getAnalysisType);
}
